import { combineReducers } from 'redux'
import {
	adminAuthReducer,
	adminUpdateProfileReducer,
	getAdminProfileReducer,
} from './adminAuthReducer'
import {
	campaignCreateReducer,
	campaignUpdateReducer,
	campaignUpdateStatusReducer,
	getAllCampaignsReducer,
	getCampaignDetailsReducer,
	getCurrentCampaignReducer,
} from './campaignReducer'
import {
	createSubmissionReducer,
	getAllSubmissionsReducer,
	getSubmissionDetailReducer,
	getUserAllSubmissionsReducer,
	updateSubmissionDetailReducer,
	userGetSubmissionDetailReducer,
} from './submissionReducer'
import {
	getAllUsersReducer,
	getUserDetailsReducer,
	getUserProfileReducer,
	userAuthReducer,
	userRegisterReducer,
	userUpdateProfileReducer,
	userVerifyEmailReducer,
} from './userAuthReducer'

const reducer = combineReducers({
	userAuth: userAuthReducer,
	userRegister: userRegisterReducer,
	userVerifyEmail: userVerifyEmailReducer,
	getUserProfile: getUserProfileReducer,
	userUpdateProfile: userUpdateProfileReducer,
	getAllUsers: getAllUsersReducer,
	getUserDetails: getUserDetailsReducer,

	adminAuth: adminAuthReducer,
	getAdminProfile: getAdminProfileReducer,
	adminUpdateProfile: adminUpdateProfileReducer,

	campaignCreate: campaignCreateReducer,
	getCurrentCampaign: getCurrentCampaignReducer,
	getCampaignDetails: getCampaignDetailsReducer,
	getAllCampaigns: getAllCampaignsReducer,
	campaignUpdate: campaignUpdateReducer,
	campaignUpdateStatus: campaignUpdateStatusReducer,

	createSubmission: createSubmissionReducer,
	getAllSubmissions: getAllSubmissionsReducer,
	getSubmissionDetail: getSubmissionDetailReducer,
	updateSubmissionDetail: updateSubmissionDetailReducer,
	getUserAllSubmissions: getUserAllSubmissionsReducer,
	userGetSubmissionDetail: userGetSubmissionDetailReducer,
})

export default reducer
